<template>
    <div class="container shipping_conf">
        <div class="panel-body">
            <h3>{{ $t('page.shop.overview')}}</h3>
            <input type="hidden" id="manage-abteilung-hidden" value=""/>
            <div class="table-responsive">
                <table class="table table-responsive">
                    <thead>
                    <th>#</th>
                    <th>{{ $t('page.shop.name')}}</th>
                    <th>{{ $t('page.shop.abteilung')}}</th>
                    <th>{{ $t('page.shop.connector')}}</th>
                    <th>{{ $t('page.shop.actions')}}</th>
                    </thead>
                    <tbody>
                    <tr v-for="(shop, index) in shops" v-if="shops != null">
                        <td>{{index+1}}</td>
                        <td>{{shop.name}}</td>
                        <td>{{shop.department.name}}</td>
                        <td>{{shop.shop_type}}</td>
                        <td>
                            <a class="btn btn-info"
                               v-bind:href="'/manage/shop/'+shop.id+'/mapping'">{{ $t('page.shop.mapping')}}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import shopService from "../../services/shopService";

    export default {
        name: "ShopOverview",
        data() {
            return {
                shops: [],
                shopModalId: null
            }
        },
        methods: {
            getShops() {
                shopService.getAll().then(
                    (response) => {
                        this.shops = response;
                    });
            },
            showModal(shopId) {
                this.shopModalId = shopId;
                this.$refs.id = shopId;
                this.$refs.modal.show();
            }
        },
        mounted() {
            this.getShops();
            this.$eventBus.$on('shop-create-edit', () => {
                this.$refs.modal.hide();
                this.getShops();
            });
        }
    }
</script>

<style scoped>

</style>